















































































































import Vue, { PropType } from 'vue';

import store from '@/store';
import { BasePacket } from '@/models/packet';
import { WebRequestStatus } from '@/models';
import * as Utils from '@/utils';

import CogsDefinition from '@/components/widgets/CogsDefinition.vue';
import PacketCard from '@/components/PacketCard.vue';
import PersistableItem from '@/components/PersistableItem.vue';

export default Vue.extend({
  components: {
    CogsDefinition,
    PacketCard,
    PersistableItem
  },

  props: {
    exclude: Array as PropType<number[]>,
    packets: {
      type: Array as PropType<BasePacket[]>,
      required: true
    }
  },

  data() {
    return {
      connectingPacketStatus: {} as {
        [key: number]: {
          statusTrackerId: number;
        };
      }
    };
  },

  computed: {
    allPackets(): BasePacket[] {
      return this.packets;
    },

    unselected(): [BasePacket, WebRequestStatus][] {
      return this.allPackets
        .filter(p => !this.exclude.includes(p.packetId))
        .map(p => {
          return [
            p,
            store.state.org.activeRequests.associate.getStatus(
              this.connectingPacketStatus[p.packetId]?.statusTrackerId
            ) || WebRequestStatus.READY
          ];
        });
    },

    selected(): [BasePacket, WebRequestStatus][] {
      return this.allPackets
        .filter(p => this.exclude.includes(p.packetId))
        .map(p => {
          return [
            p,
            store.state.org.activeRequests.associate.getStatus(
              this.connectingPacketStatus[p.packetId]?.statusTrackerId
            ) || WebRequestStatus.READY
          ];
        });
    },

    public(): [BasePacket, WebRequestStatus][] {
      return store.state.org.publicPackets.map(([p]) => [
        p,
        store.state.org.activeRequests.associate.getStatus(
          this.connectingPacketStatus[p.packetId]?.statusTrackerId
        ) || WebRequestStatus.READY
      ]);
    },

    publicUnselected(): [BasePacket, WebRequestStatus][] {
      return this.public.filter(([p]) => !this.exclude.includes(p.packetId));
    }
  },

  methods: {
    select(packet: BasePacket) {
      /// Create a temp id which the parent component can optionally use if they want
      /// track the status of an API call which happens after selection.
      const statusTrackerId = Utils.idGenerator.next();

      this.connectingPacketStatus = {
        ...this.connectingPacketStatus,
        [packet.packetId]: { statusTrackerId }
      };

      this.$emit('select', { packet, statusTrackerId });
    },

    remove(packet: BasePacket) {
      const statusTrackerId = Utils.idGenerator.next();

      this.connectingPacketStatus = {
        ...this.connectingPacketStatus,
        [packet.packetId]: { statusTrackerId }
      };

      this.$emit('deselect', { packet, statusTrackerId });
    }
  }
});
